import { DropdownFoldMenu } from 'components/Dropdown/menus/Fold/DropdownFoldMenu';
import { takeActionDropdownDataByLocale } from 'mappings/TakeActionDropdown/takeActionDropdownDataByLocale';

import {
  takeActionDropdownDataByResourcesItemType,
  takeActionDropdownDataBySearchItemType,
} from './takeActionDropdownConstants';

type Props = {
  locale: UserLocale;
  trackClickedContext: string;
};

export function TakeActionDropdownMenu({ locale, trackClickedContext }: Props) {
  const { search, resources } = takeActionDropdownDataByLocale[locale];

  return (
    <DropdownFoldMenu
      left={{
        title: search.title,
        items: search.items.map((searchItem) => {
          const { iconName, qaId, trackClickedName } =
            takeActionDropdownDataBySearchItemType[searchItem.type];

          return {
            iconName,
            title: searchItem.title,
            href: searchItem.href,
            qaId,
            trackClicked: {
              name: trackClickedName,
              context: trackClickedContext,
            },
            fullPageRedirect: true,
          };
        }),
      }}
      right={{
        title: resources.title,
        items: resources.items.map((resourceItem) => {
          const { image, qaId, trackClickedName } =
            takeActionDropdownDataByResourcesItemType[resourceItem.type];

          return {
            image,
            title: resourceItem.title,
            description: resourceItem.description,
            href: resourceItem.href,
            qaId,
            trackClicked: {
              name: trackClickedName,
              context: trackClickedContext,
            },
          };
        }),
      }}
    />
  );
}
